<p-confirmDialog appendTo="body" />

<!-- Task Form Modal -->
<p-dialog
  [header]="formTitle()"
  [(visible)]="showForm"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [focusTrap]="false"
  [focusOnShow]="false"
  appendTo="body"
  [baseZIndex]="10000"
  [style]="{ width: '600px', 'max-width': '90vw' }"
  [breakpoints]="{ '768px': '95vw', '480px': '100vw' }"
  styleClass="task-form-dialog">
  <div class="task-form">
    <div class="form-grid grid p-fluid">
      <div class="col-12">
        <div class="field-group">
          <span class="field-label">
            Descrição Resumida
            <span class="required">*</span>
          </span>
          <input
            pInputText
            [ngModel]="formSummary()"
            (ngModelChange)="formSummary.set($event)"
            placeholder="Resumo da tarefa"
            class="w-full" />
        </div>
      </div>

      <div class="col-12">
        <div class="field-group">
          <span class="field-label"> Descrição Completa </span>
          <textarea
            pTextarea
            [rows]="4"
            [ngModel]="formDescription()"
            (ngModelChange)="formDescription.set($event)"
            placeholder="Detalhes da tarefa..."
            style="resize: vertical; min-height: 100px; max-height: 400px"
            class="w-full"></textarea>
        </div>
      </div>

      <div class="col-12">
        <div class="field-group">
          <span class="field-label">
            Desenvolvedor Responsável
            <span class="required">*</span>
          </span>
          <app-favorite-select
            [options]="usersList()"
            [(ngModel)]="formUserId"
            optionLabel="name"
            optionValue="id"
            placeholder="Selecione o desenvolvedor"
            class="w-full"
            appendTo="body"
            [filter]="true"
            [autofocusFilter]="true"
            (onFilter)="onUserFilter($event)"
            [loading]="usersLoading()"
            emptyFilterMessage="Nenhum desenvolvedor encontrado"
            [favorites]="true"
            [favoritesKey]="FavoriteKey.TicketDevelopers" />
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field-group">
          <span class="field-label">
            Esforço Estimado (pontos)
            <span class="required">*</span>
          </span>
          <input
            pInputText
            type="number"
            [ngModel]="formEstimatedEffort()"
            (ngModelChange)="formEstimatedEffort.set($event)"
            placeholder="1 ponto = 4 horas"
            class="w-full" />
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field-group">
          <span class="field-label">Data de Previsão</span>
          <p-datepicker
            [(ngModel)]="formExpectedDate"
            dateFormat="dd/mm/yy"
            placeholder="Selecione a data"
            class="w-full"
            appendTo="body" />
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field-group">
          <span class="field-label">Dificuldade</span>
          <p-select
            [options]="difficultyOptions"
            [(ngModel)]="formDifficulty"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecione"
            class="w-full"
            appendTo="body" />
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="field-group">
          <span class="field-label">
            Status
            <span class="required">*</span>
          </span>
          <app-favorite-select
            [options]="statusesList()"
            [(ngModel)]="formStatusId"
            optionLabel="description"
            optionValue="id"
            placeholder="Selecione o status"
            class="w-full"
            appendTo="body"
            [filter]="true"
            [autofocusFilter]="true"
            (onFilter)="onStatusFilter($event)"
            [loading]="statusesLoading()"
            emptyFilterMessage="Nenhum status encontrado"
            [favorites]="true"
            [favoritesKey]="FavoriteKey.TicketStatuses" />
        </div>
      </div>

      <div class="col-12">
        <div class="field-group">
          <span class="field-label">Sistema</span>
          <app-entity-picker
            title="Selecionar sistema"
            placeholder="Nenhum sistema selecionado"
            labelField="description"
            [searchFn]="searchSystemsFn"
            [value]="formSystem()"
            (valueChange)="formSystem.set($event)" />
        </div>
      </div>

      <div class="col-12">
        <div class="task-form-checks">
          <div class="field-group field-group--inline">
            <p-checkbox
              [ngModel]="formFinished()"
              [binary]="true"
              inputId="taskFinished"
              [disabled]="isFinishedDisabled()"
              (onChange)="formFinished.set($event.checked)" />
            <label for="taskFinished">{{ formFinished() ? 'Concluída' : 'Não concluída' }}</label>
          </div>
          <div class="field-group field-group--inline">
            <p-checkbox
              [ngModel]="formChangeExpectedDate()"
              [binary]="true"
              inputId="changeExpectedDate"
              pTooltip="Atualizar previsão final do chamado"
              tooltipPosition="top"
              (onChange)="formChangeExpectedDate.set($event.checked)" />
            <label for="changeExpectedDate">Atualizar previsão</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #footer>
    <p-button
      label="Cancelar"
      icon="pi pi-times"
      severity="secondary"
      [outlined]="true"
      (onClick)="closeForm()" />
    <p-button
      label="Salvar"
      icon="pi pi-check"
      [loading]="saving()"
      [disabled]="
        !formSummary().trim() ||
        !formStatusId() ||
        !formUserId() ||
        formEstimatedEffort() === null ||
        formEstimatedEffort() === undefined
      "
      (onClick)="saveTask()" />
  </ng-template>
</p-dialog>

<!-- Bulk Update Modal -->
<p-dialog
  header="Atualização em Massa"
  [(visible)]="showBulkUpdate"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [focusTrap]="false"
  [focusOnShow]="false"
  appendTo="body"
  [baseZIndex]="10000"
  [style]="{ width: '780px', 'max-width': '96vw' }"
  [breakpoints]="{ '768px': '95vw', '480px': '100vw' }"
  styleClass="bulk-update-dialog">
  <div class="bulk-update-layout">
    <!-- Linha principal: lista de tarefas (esquerda) + campos (direita) -->
    <div class="bulk-top-row">
      <!-- ============================
           COLUNA ESQUERDA: Seleção de Tarefas
           ============================ -->
      <div class="bulk-col--tasks">
        <div class="bulk-col-header">
          <span class="bulk-col-title">
            <i class="pi pi-list"></i>
            Selecionar tarefas
          </span>
          <div class="bulk-select-controls">
            <span class="bulk-count-badge">
              {{ selectedCount() }} / {{ tasks().length }} selecionada(s)
            </span>
            <p-button
              [label]="allTasksSelected() ? 'Desmarcar todas' : 'Marcar todas'"
              [severity]="allTasksSelected() ? 'secondary' : 'primary'"
              size="small"
              [text]="true"
              (onClick)="toggleSelectAll()" />
          </div>
        </div>

        <div class="bulk-tasks-scroll">
          @for (task of tasks(); track task.id) {
            <div
              class="bulk-task-card"
              [class.bulk-task-card--selected]="isTaskSelected(task.id)"
              (click)="toggleTaskSelection(task.id)">
              <p-checkbox
                [ngModel]="isTaskSelected(task.id)"
                [binary]="true"
                class="bulk-task-checkbox-readonly" />

              <div class="bulk-task-body">
                <!-- Linha 1: Sequência + título da tarefa -->
                <div class="bulk-task-row-top">
                  <span class="bulk-task-seq">#{{ task.sequence }}</span>
                  <span class="bulk-task-label" [title]="getTaskCardLabel(task)">{{
                    getTaskCardLabel(task)
                  }}</span>
                </div>

                <!-- Linha 2: dificuldade + status -->
                <div class="bulk-task-row-meta">
                  @if (task.difficulty) {
                    <span class="task-difficulty" [ngClass]="getDifficultyClass(task.difficulty)">
                      {{ task.difficulty | difficulty }}
                    </span>
                  }
                  @if (task.status) {
                    <span
                      class="task-status"
                      [style.background]="getStatusColor(task.status.description)">
                      {{ task.status.description }}
                    </span>
                  }
                </div>

                <!-- Linha 3: dev, pontos, data, conclusão -->
                <div class="bulk-task-row-meta">
                  @if (task.user) {
                    <span class="bulk-task-meta-item">
                      <i class="pi pi-user"></i>
                      {{ task.user.name }}
                    </span>
                  }
                  @if (task.estimated_effort !== null && task.estimated_effort !== undefined) {
                    <span class="bulk-task-meta-item">
                      <i class="pi pi-bolt"></i>
                      {{ task.estimated_effort }} pt
                    </span>
                  }
                  @if (task.expected_date) {
                    <span class="bulk-task-meta-item">
                      <i class="pi pi-calendar"></i>
                      {{ formatDate(task.expected_date) }}
                    </span>
                  }
                  @if (task.finished) {
                    <span class="bulk-task-finished-badge">
                      <i class="pi pi-check-circle"></i> Concluída
                    </span>
                  }
                </div>
              </div>
            </div>
          }
          @if (tasks().length === 0) {
            <div class="bulk-tasks-empty">
              <i class="pi pi-check-square"></i>
              Nenhuma tarefa disponível
            </div>
          }
        </div>
      </div>

      <!-- ============================
           COLUNA DIREITA: Campos de Atualização
           ============================ -->
      <div class="bulk-col--fields">
        <span class="bulk-col-title">
          <i class="pi pi-pencil"></i>
          Dados a atualizar
        </span>

        <div class="bulk-field-group">
          <label class="bulk-field-label">Novo Status</label>
          <app-favorite-select
            [options]="statusesList()"
            [(ngModel)]="bulkStatusId"
            optionLabel="description"
            optionValue="id"
            placeholder="Selecione"
            class="w-full"
            appendTo="body"
            [filter]="true"
            [autofocusFilter]="false"
            (onFilter)="onStatusFilter($event)"
            [loading]="statusesLoading()"
            emptyFilterMessage="Nenhum status encontrado"
            [favorites]="true"
            [favoritesKey]="FavoriteKey.TicketStatuses" />
        </div>

        <div class="bulk-field-group">
          <label class="bulk-field-label">Novo Desenvolvedor</label>
          <app-favorite-select
            [options]="usersList()"
            [(ngModel)]="bulkUserId"
            optionLabel="name"
            optionValue="id"
            placeholder="Selecione"
            class="w-full"
            appendTo="body"
            [filter]="true"
            [autofocusFilter]="false"
            (onFilter)="onUserFilter($event)"
            [loading]="usersLoading()"
            emptyFilterMessage="Nenhum desenvolvedor"
            [favorites]="true"
            [favoritesKey]="FavoriteKey.TicketDevelopers" />
        </div>

        <div class="bulk-field-group">
          <label class="bulk-field-label">Nova Data de Previsão</label>
          <p-datepicker
            [(ngModel)]="bulkExpectedDate"
            dateFormat="dd/mm/yy"
            placeholder="Selecione"
            class="w-full"
            [disabled]="bulkRemoveExpectedDate()"
            (ngModelChange)="onBulkExpectedDateChange($event)"
            appendTo="body" />
        </div>

        @if (bulkExpectedDate() && !bulkRemoveExpectedDate()) {
          <div class="bulk-field-group">
            <div class="field-group field-group--inline">
              <p-toggleswitch [(ngModel)]="bulkApplyDateToTicket" inputId="bulkApplyDateToTicket" />
              <label for="bulkApplyDateToTicket">Editar previsão do chamado</label>
            </div>
          </div>
        }

        <div class="bulk-field-group">
          <div class="field-group field-group--inline">
            <p-checkbox
              [ngModel]="bulkRemoveExpectedDate()"
              [binary]="true"
              inputId="bulkRemoveExpectedDate"
              (onChange)="onBulkRemoveExpectedDateChange($event.checked)" />
            <label for="bulkRemoveExpectedDate">Remover data previsão</label>
          </div>
        </div>

        <div class="bulk-field-group">
          <label class="bulk-field-label">Conclusão das tarefas</label>
          <p-selectbutton
            [options]="bulkFinishOptions"
            [(ngModel)]="bulkFinish"
            optionLabel="label"
            optionValue="value"
            size="small"
            styleClass="bulk-finish-select" />
        </div>

        @if (selectedCount() > 0) {
          <div class="bulk-info-box bulk-info-box--primary">
            <i class="pi pi-info-circle"></i>
            <span>
              Afetará <strong>{{ selectedCount() }}</strong> de
              <strong>{{ tasks().length }}</strong> tarefa(s).
            </span>
          </div>
        } @else {
          <div class="bulk-info-box bulk-info-box--warn">
            <i class="pi pi-exclamation-triangle"></i>
            <span>Selecione ao menos uma tarefa à esquerda.</span>
          </div>
        }
      </div>
    </div>
  </div>

  <ng-template #footer>
    <p-button
      label="Cancelar"
      icon="pi pi-times"
      severity="secondary"
      [outlined]="true"
      (onClick)="closeBulkUpdate()" />
    <p-button
      label="Confirmar Atualização"
      icon="pi pi-check"
      [loading]="saving()"
      [disabled]="
        selectedCount() === 0 ||
        (!bulkStatusId() &&
          !bulkUserId() &&
          !bulkExpectedDate() &&
          !bulkRemoveExpectedDate() &&
          bulkFinish() === null)
      "
      (onClick)="confirmBulkUpdate()" />
  </ng-template>
</p-dialog>

<div class="ticket-tasks-wrapper">
  <!-- Task List View -->
  <div class="task-list-view">
    <div class="task-list-header">
      <span class="task-count"
        >{{ tasks().length }} tarefa(s) · {{ finishedPoints() }}/{{ totalPoints() }} ponto(s)</span
      >
      @if (canEdit) {
        <div class="header-actions">
          <p-button
            icon="pi pi-pencil"
            label="Atualização em massa"
            severity="secondary"
            size="small"
            [disabled]="tasks().length === 0"
            (onClick)="openBulkUpdate()" />
          <p-button
            icon="pi pi-plus"
            label="Nova Tarefa"
            size="small"
            (onClick)="openNewTaskForm()" />
        </div>
      }
    </div>
    <div class="overall-progress-row">
      <div class="overall-progress-bar">
        <div
          class="overall-progress-fill"
          [style.width.%]="overallProgress()"
          [style.background-color]="getProgressColor(overallProgress())"></div>
      </div>
      <span class="overall-progress-label">{{ overallProgress() | number: '1.0-0' }}%</span>
    </div>

    @if (tasks().length === 0) {
      <div class="empty-state">
        <i class="pi pi-check-square"></i>
        <p>Nenhuma tarefa cadastrada</p>
      </div>
    } @else {
      <div class="task-items">
        @for (task of tasks(); track task.id; let i = $index) {
          <div
            class="task-card"
            [attr.data-task-id]="task.id"
            [class.task-finished]="task.finished"
            [class.dragging]="draggedIndex() === i"
            [class.drop-target-top]="dropTarget()?.index === i && dropTarget()?.position === 'top'"
            [class.drop-target-bottom]="
              dropTarget()?.index === i && dropTarget()?.position === 'bottom'
            "
            [draggable]="canEdit"
            (dragstart)="onDragStart(i)"
            (dragover)="onDragOver($event, i)"
            (dragleave)="onDragLeave()"
            (drop)="onDrop()"
            (dragend)="onDragEnd()">
            @if (canEdit) {
              <div class="task-drag-handle">
                <i class="pi pi-bars"></i>
              </div>
            }

            <div class="task-checkbox">
              <p-checkbox
                [ngModel]="task.finished"
                [binary]="true"
                [disabled]="isTaskToggleDisabled(task)"
                (onChange)="toggleTaskFinished(task, $event.checked)" />
            </div>

            <div class="task-content">
              <div class="task-main-row">
                <span class="task-summary" [class.task-done-text]="task.finished">
                  {{ task.summary || task.description }}
                </span>
              </div>

              <div class="task-badges-row">
                @if (getActiveTaskLog(task); as activeTaskLog) {
                  <span class="task-active-log-badge">
                    <i class="pi pi-spin pi-clock"></i>
                    {{ activeTaskLog.user?.name ?? 'Usuário' }} apontando
                  </span>
                }
                <span class="task-difficulty" [ngClass]="getDifficultyClass(task.difficulty)">
                  {{ task.difficulty | difficulty }}
                </span>
                @if (task.status) {
                  <span
                    class="task-status"
                    [style.background]="getStatusColor(task.status.description)">
                    {{ task.status.description }}
                  </span>
                }
              </div>

              @if (task.description && task.description !== task.summary) {
                <div class="task-description-row">
                  <markdown [data]="task.description"></markdown>
                </div>
              }

              <div class="task-meta-row">
                @if (task.user; as taskUser) {
                  <span class="task-user">
                    <i class="pi pi-user"></i>
                    {{ taskUser.name }}
                  </span>
                }
                @if (task.estimated_effort !== null && task.estimated_effort !== undefined) {
                  <span class="task-effort">
                    <i class="pi pi-bolt"></i>
                    {{ task.estimated_effort }} pt(s)
                  </span>
                }
                @if (task.expected_date) {
                  <span class="task-date">
                    <i class="pi pi-calendar"></i>
                    {{ formatDate(task.expected_date) }}
                  </span>
                }
                @if (task.systems && task.systems.length > 0) {
                  <span class="task-system">
                    <i class="pi pi-box"></i>
                    {{ task.systems[0].description }}
                  </span>
                }
              </div>

              <div class="task-progress-row">
                <div class="progress-bar-container">
                  <div
                    class="progress-bar-fill"
                    [style.width.%]="task.progress"
                    [style.background-color]="getProgressColor(task.progress)"></div>
                </div>
                <span class="progress-label">{{ task.progress | number: '1.0-0' }}%</span>
              </div>
            </div>

            <div class="task-actions">
              <button
                class="task-action-btn"
                [class.task-action-btn--blocked]="isTimeEntryBlocked(task)"
                [attr.aria-disabled]="isTimeEntryBlocked(task) ? 'true' : null"
                [pTooltip]="getTaskTimeEntryTooltip(task)"
                tooltipPosition="top"
                (click)="onStartTimeEntry(task)">
                <i class="pi {{ getTaskTimeEntryIcon(task) }}"></i>
              </button>
              @if (canEdit) {
                <button
                  class="task-action-btn"
                  pTooltip="Editar"
                  tooltipPosition="top"
                  (click)="openEditTaskForm(task)">
                  <i class="pi pi-pencil"></i>
                </button>
                <button
                  class="task-action-btn task-action-btn--danger"
                  pTooltip="Excluir"
                  tooltipPosition="top"
                  (click)="confirmDeleteTask(task)">
                  <i class="pi pi-trash"></i>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
